<template>
<div v-role="'func'">
<div>
   <v-container class="grey lighten-5" style="margin-top:20px;">
  <v-row>
    <v-col cols="12" md="12">
            <v-card
              max-width="1000"
              style="margin:auto;margin-top:20px;"
            >
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
              <v-card-text>
                 
                  <v-row>
                    <v-col class="d-flex" cols="12" sm="6" md="6" >
                      <p class="display-1 text--primary">
                          Actualizar dados académicos  
                      </p>

                    </v-col>
                     
                  </v-row>
               <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
          
                    <v-row>

                        <v-col class="d-flex" cols="12" sm="6" md="5">

                          <v-autocomplete
                            v-model="editedItem.estudante"
                            :items="estudantes"
                            :loading="isLoading_"
                            :rules="ruleRequired"
                            :search-input.sync="search"
                            color="primary"
                            item-text="nome"
                            item-value="nome"
                            label="Nome do estudante"
                            placeholder="Digite o nome do estudante"
                            prepend-icon="mdi-database-search"
                            return-object
                            @change="SelecionaEstudante()"
                          ></v-autocomplete>

                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6" md="2">
                            <v-combobox
                              v-model="editedItem.anoacademico"
                               :rules="ruleRequired"
                              item-value="pkAnoacademico"
                              item-text="descricao"
                              required
                              :disabled="disabled"
                              :hint="detalhe"
                              persistent-hint
                              :items="classes"
                              label="Selecione a nova Classe"
                              @change="loadTurmaClasse"
                            ></v-combobox>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6" md="2">
                              <v-combobox
                                v-model="editedItem.turmaSelected"
                                :rules="ruleRequired"
                                item-text="descricao"
                                :disabled="disabled"
                                required
                                :hint="detalhe"
                                persistent-hint
                                :items="turmasFiltered"
                                label="Selecione a nova Turma"
                                return-object
                                @change="ObterNumeroEstudantesTurma()"
                            ></v-combobox>
                          </v-col>

                          <v-col class="d-flex" cols="12" sm="6" md="2">

                              <v-btn color="#ee44aa" style="color:white;" @click="ConfirmarMatricula()" :disabled="!valid || vagasDisponiveis <=0">Confirmar</v-btn>
                      </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="2">
                              <v-progress-circular
                              v-if="progresso"
                              indeterminate
                              color="green"
                          ></v-progress-circular>
                        </v-col>
                        <v-col md="12" v-if="editedItem.turmaSelected !== null">
                          <v-row>
                        <v-card
                          max-width="300px"
                          class="margin-card"
                        >
                          <v-card-text>
                            <v-row>
                                  <v-col md="12">
                                  <span class="boldText">Capacidade da Turma: </span>
                                  <span>{{(editedItem.turmaSelected !== null)?editedItem.turmaSelected.capacidade:''}}</span>
                                  </v-col>
                                  <v-col md="12">
                                  <span class="boldText">Nº Estudantes na Turma: </span>
                                  <span>{{(numeroEstudantesCadastrado.length)?numeroEstudantesCadastrado[0].qtdEstudante:0}}</span>
                                  </v-col>
                                  <v-col md="12">
                                  <span class="boldText">Vagas disponíveis: </span>
                                  <span :style="(vagasDisponiveis > 0)?'color:green;font-weight:bold;':'color:red;font-weight:bold;'">{{vagasDisponiveis}}</span>
                                  </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        </v-row>
                        </v-col>
                    </v-row>
              </v-form>
              </v-card-text>
            </v-card>
    </v-col>
    <v-col cols="12" md="12">
        <v-card
         max-width="1000"
         style="margin:auto;"
        >
            <v-list-item>
              <v-list-item-avatar color="grey"></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title  style="font-size:18px;">Resultado da Pesquisa</v-list-item-title>
                <v-list-item-subtitle>dados do estudante</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-row>
               <v-col md="6">
                <v-card-text>
                  <strong> Dados Pessoais</strong>
                </v-card-text>
                <hr>
                <v-row>
                <v-col md="6">
                      <v-chip color="pink" style="margin:4px;color:white">Nome:{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.nome):''}}</v-chip>
                </v-col>
                <v-col md="6">
                      <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.idMatricula):''}}</v-chip>
                </v-col>
                </v-row>
                <v-row>
                <v-col md="4">
                      <v-chip style="margin:4px">Genero:<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.sexo):''}}</strong></v-chip>
                </v-col>
                <v-col md="8">
                      <v-chip style="margin:4px">Data de Nascimento:<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.data_nascimento):''}}</strong></v-chip>
                </v-col>
                </v-row>
                <v-row>
                <v-col md="6">
                      <v-chip style="margin:4px">Natural de :<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.nomedopai):''}}</strong></v-chip>
                </v-col>
                <v-col md="6">
                      <v-chip style="margin:4px">BI:<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.bi):''}}</strong></v-chip>
                </v-col>
                </v-row>

                <v-row>
                <v-col md="6">
                      <v-chip style="margin:4px">Filho de :<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.pai):''}}</strong></v-chip>
                </v-col>
                <v-col md="6">
                      <v-chip style="margin:4px">e De:<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.mae):''}}</strong></v-chip>
                </v-col>
                </v-row>

                <v-row>
                <v-col md="12">
                      <v-chip style="margin:4px">Contacto:<strong>{{(this.editedItem.estudante !== null)?(this.editedItem.estudante.telefone):''}}</strong></v-chip>
                </v-col>
                </v-row>

                <hr>
              </v-col>
               <v-col md="6">
                  <v-card-text>
                    <strong>Histórico Académico</strong>
                  </v-card-text>
                  <hr>

                  <v-data-table 
                          :headers="headers"
                          :items="historicoAcademico"
                        >

                    </v-data-table>

                </v-col>
            </v-row>
        </v-card>
    </v-col>
  </v-row>
   </v-container>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import axiosPedagogico from '../../plugins/axiosFinancas'
import Swal from 'sweetalert2'
const ls = require('local-storage')

export default {
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    estudantes: [],
    turmasAll: [],
    numeroEstudantesCadastrado:[],
    listaDeClassesPorLancarNotas: [],
    semestres: [{id:1, descricao:'Iº Semestre'},{id:2,descricao:'IIº Semestre'}],
    turmasFiltered: [],
    pesquisa_parameto: [],
    historicoAcademico:[],
    valid: true,
    jaMatriculado: '',
    classe: '',
    detalhe: '',
    disabled: false,
    progresso: false,
    isLoading: false,
    isLoading_: false,
    search: null,
    exibe: false,
    acesso: [],
    turmasAll: [],
    estudanteSelected: null,
    classes:[],
    classesFiltered: [],
    anosacademicos: [],
    overlay: false,
    descriptionLimit: 60,
    entries: [],
    classes: [],
    search2: null,
    turma: null,
    filter: false,
    editedItem: {
      objecto: null,
      Turma: null,
      semestre: null,
      anoacademico: null,
      classe: null,
      estudante:null,
      turmaSelected: null,
      autor:ls.get('nomeUsuario')
    },
    defaultItem: {
      objecto: null,
      Turma: null,
      classe: null,
      anoacademico: null,
      semestre: null,
      estudante:null,
      turmaSelected:null,
      autor:ls.get('nomeUsuario')
    },
    headers: [
      { text: 'Curso', value: 'curso' },
      { text: 'Ultima Classe Feita', value: 'classe' },
      { text: 'Ultima turma', value: 'turma' },
      { text: 'Anolectivo', value: 'anoLectivo' },
      { text: 'Resultado', value: 'resultado' },
    ],
    ruleRequired: [value => value || 'campo obrigatorio']
  }),

  computed: {

    vagasDisponiveis(){
       return parseInt((this.editedItem.turmaSelected === null)?0:this.editedItem.turmaSelected.capacidade) - parseInt((this.numeroEstudantesCadastrado.length)?this.numeroEstudantesCadastrado[0].qtdEstudante:0)
     },

    ListaActividades () {
      return ls.get('lista_actividades')
    },
    anolectivoActual(){
      return ls.get('anolectivo')
    },
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    }
  },

  watch: {

    search (val) {
      if (val.length > 3) {
        if (!this.estudantes.filter(t => t.nome.includes(val)).length) {
          this.estudantes = []
        }
        return this.PesquisarPedGlobal(val)
      }
    }

  },
  created () {
     this.initializeClasses();
     this.initializeturmasAll()
  },

  methods: {

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get('/classeFindAll2').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios.get('/turmasFindAlls').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },


    async ConfirmarMatricula(){

      if(this.$refs.form.validate()){
        this.overlay = true
          let params = {
            dados: this.editedItem
          }
          try {
            this.isLoading = true;
           let result = await axios.post('/confirmacaoInsertOrUpdate',params).then(res => res.data);
           if(result.affectedRows >= 1){
              Swal.fire('Informação','Confirmação feita com sucesso','success')
              this.editedItem = this.defaultItem
           }else{
            Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação.','error')
           }
          } catch (error) {
            this.text = error;
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
          } finally {
            this.overlay = false
            this.isLoading = false;
          }


      }

    },
  


    async SelecionaEstudante () {
        if(this.editedItem.estudante !== null){  // Se o estudante for encontrado,
          this.historicoAcademico = await this.ObterHistoricoAcademico(this.editedItem.estudante).then((res)=>res.data)
          if(this.historicoAcademico.length){
              if(this.historicoAcademico[0].anoLectivo === this.anolectivoActual){
                this.valid= false
                 Swal.fire('Informação','Estudante já confirmado no anolectivo actual','warning')
              }
          }
        }
    },

    

    async Initialize (searchDB) {
      this.isLoading = true
      this.isLoading_ = true
      if (!this.estudantes.length) {
        if (searchDB) {
          var payload = '{ "find" : "' + searchDB + '" }'
        } else {
          payload = '{ "find":"all" }'
        }
        try {
          // this.isLoading = true
          this.estudantes = await axios
            .get('/EstudantesConfirmacao/' + payload)
            .then(res => res.data)
          this.isLoading = false
          this.isLoading_ = false
        } catch (error) {
          this.isLoading = false
          this.isLoading_ = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
      this.isLoading = false
      this.isLoading_ = false
    },

    async  PesquisarPedGlobal(val){
       try {
         this.isLoading = true
         this.estudantes = await axios.post('/PesquisaEstudantePed',{nome:val}).then((res)=>res.data)
         this.isLoading = false
       } catch (error) {

        this.isLoading = false
         Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','warning')
       }

    },

    async ObterNumeroEstudantesTurma (){
      try {
        this.numeroEstudantesCadastrado = await axios.post('ObterNumeroIscritoEstudantesTurma',{turma:this.editedItem.turmaSelected}).then((res)=>res.data)
      } catch (error) {
        
      }
    },


      async  ObterHistoricoAcademico(params){
       try {
          return await axios.post('/ObterInscricaoTurmaEstudante',params)
        } catch (error) {
          Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','warning')
       }

    },

    ListarEstudantes (item) {
      this.$store.state.objturma = item
      this.$router.push('ListaAlunos')
    },

    async save () {
      if ((this.$refs.form.validate())) {
        this.progresso = true
        let params =
              { 
                autor: ls.get('nomeUsuario'),
                turma_id: this.editedItem.Turma.id,
                turmaDescricao: this.editedItem.Turma.turmadescricao,
                curso: this.editedItem.Turma.descricao,
                classe: this.editedItem.classe.descricao,
                estudante_id: this.editedItem.objecto.pk_estudante

              }
        try {
          let msg = await axios
            .post('/confirmarMatricula-Fin', params)
            .then(res => res.data)
          if(msg.affectedRows >= 1){
            this.progresso = false
              Swal.fire({
                    title: 'Informação',
                    text: "Confirmação feita com sucesso!",
                    icon: 'success',
                    showCancelButton: true,
                    cancelButtonText:'Fechar',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ir em pagamentos ?',
                    reverseButtons:true,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.$router.push('esc-pagamento')
                    }
                  })
              this.Limpar()
          }else{
              utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação');
          }
          
        } catch (error) {
          this.progresso = false
          utilitarios.showAlertMessage('error','Ocorreu um erro ao tentar efectuar a operação');
        }
      }
    },

    Limpar () {
        this.editedItem.objecto = null
        this.editedItem.Turma = null
        this.editedItem.classe = null
        this.historicoAcademico=[]
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)

        console.log(this.turmasAll.filter(t=>t.idCurso === 13 && t.idAno_Academico === 3))
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async turmaFindWithEstudanteCount () {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
          console.log(this.listaDeClassesPorLancarNotas);
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },

    async verificaSeJaConfirmado(){
       try {
        return  await axios
          .post('/Estudante-ja-Confirmado', this.editedItem.objecto)  
          .then(res => res.data)
       } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios.get('/anoacademicoFindAll').then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }finally{this.isLoading = false}
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },
    async loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesFiltered = this.classes.filter( c=> c.nivel === this.editedItem.objecto.nivel_ensino)
      let result  = await this.verificaSeJaConfirmado().then()
      if( result.qtd  <= 0 ){
        this.disabled = false
      }else{ // Já tem a matrícula ou confirmação feita neste anolectivo
        //this.disabled = true
        this.$store.dispatch('textMessage', {msg: 'Estudante já confirmado no anolectivo actual',classMessage: 'msgError',timeout: 8000})
      }
    },

    loadTurmaClasse () {
      this.turmasFiltered = this.turmasAll.filter( t=> t.idCurso ===  this.editedItem.estudante.idCurso && t.idAno_Academico === this.editedItem.anoacademico.idAno_Academico)
    }

  }
}
</script>
<style scoped>

.boldText{
   font-weight:bolder;
   font-size:15px;
}


</style>
